import React from 'react';
import {
  required,
  Edit,
  TabbedForm,
  FormTab,
  TextInput,
  ReferenceInput,
  AutocompleteInput,
  NumberInput,
  BooleanInput
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

// own ui
import EditTitle from '../../ui/edit-title';
import CustomEditToolbar from '../../ui/custom-edit-toolbar';

export const styles =
{
  inlineWidth: { width: '20em' },
  inlineFormGroup: { display: 'inline-block', marginRight: 20 }
};

const useStyles = makeStyles(styles);
const validateName = [required('Digite o nome!')];
const validateCity = [required('Selecione uma cidade!')];
const optionRendererCity = city => city ? `${city.name} - ${city.state.name}` : ``;

const CollectionPointPassportEdit = (props) =>
{
  const classes = useStyles();

  return (
  <Edit {...props} title={ <EditTitle subtitle="Editar Ponto de Retirada de Passaporte: " value="name" /> }>
    <TabbedForm redirect="/collection-point-passport" toolbar={<CustomEditToolbar />} >
      <FormTab label="Dados">
        <TextInput source="name" label="Nome" fullWidth={true} validate={validateName} />
        <TextInput source="responsibility_name" label="Responsável" fullWidth={true} />
        <TextInput source="contact_phone" label="Telefone de Contato" fullWidth={true} />
        <TextInput source="contact_email" label="E-mail de Contato" type="email" fullWidth={true} />
        <BooleanInput source="active" label="Ativo" />
      </FormTab>
      <FormTab label="Endereço">
        <ReferenceInput label="Cidade" source="address.city_id" fullWidth={true} reference="setup/cities" validate={validateCity}>
          <AutocompleteInput optionText={optionRendererCity} optionValue="id" limitChoicesToValue={true} shouldRenderSuggestions={(val) => { return val ? val.trim().length > 2 : false }} />
        </ReferenceInput>
        <TextInput source="address.street" label="Rua" fullWidth={true} />
        <TextInput source="address.number" label="Número" className={classes.inlineWidth} formClassName={classes.inlineFormGroup} fullWidth={true} />
        <TextInput source="address.zip_code" label="CEP" className={classes.inlineWidth} formClassName={classes.inlineFormGroup} fullWidth={true}  />
        <TextInput source="address.complement" label="Complemento" fullWidth={true} />
        <TextInput source="address.neighborhood" label="Bairro" fullWidth={true} />
        <NumberInput source="address.lat" label="Latitude" className={classes.inlineWidth} formClassName={classes.inlineFormGroup} />
        <NumberInput source="address.lng" label="Longitude" className={classes.inlineWidth} formClassName={classes.inlineFormGroup} />
      </FormTab>
    </TabbedForm>
  </Edit>
)};

export default CollectionPointPassportEdit;
